import { Injectable, inject } from '@angular/core';
import { ApiService } from '@app/services/api.service';
import { AresInterface } from '@app/interfaces/ares.interface';
import { SnackbarService } from '@app/services/snackbar.service';

@Injectable({ providedIn: 'root' })
export class AresService extends ApiService<AresInterface> {
    protected readonly snackbarService = inject(SnackbarService);

    // @API ares
    protected serviceName = 'ares';

    constructor() {
        super();
        this.initConnection();
    }

    public findAres(idNumber: string): Promise<AresInterface | void> {
        return new Promise((resolve, reject) => {
            idNumber = idNumber?.trim();
            if (idNumber && idNumber.length === 8) {
                // @API ares.get
                this.get(idNumber)
                    .then((ares: AresInterface) => {
                        if (ares?.idNumber) {
                            this.snackbarService.showSuccess(
                                'Firma byla úspěšně nalezena v systému Ares a její údaje byly načteny do formuláře'
                            );
                            resolve(ares);
                        } else {
                            this.snackbarService.showError('Bohužel, tohle IČO nebylo nalezeno v systému Ares');
                            resolve();
                        }
                    })
                    .catch(() => {
                        reject();
                    });
            } else {
                this.snackbarService.showError('IČO musí mít 8 čísel');
                resolve();
            }
        });
    }
}
